<script setup lang="ts">
interface Item {
	content: string
}

interface Section {
	name: string
	items: Item[]
}

const roadmapSections: Section[] = [
	{
		name: 'Q3 - 2025',
		items: [
			{
				content: 'The ability to import products from CSV files.',
			},
			{
				content: 'Price conversion system, allowing you to add shipping costs, convert currencies, and more. This will give a better picture of the price differences between you and your competitors.',
			},
			{
				content: 'Two factor authentication for added security.',
			},
		],
	},
	{
		name: 'Q4 - 2025',
		items: [
			{
				content: 'Implement a dashboard with a more detailed overview of your store and competitors. We are open to suggestions on what you would like to see here.',
			},
		],
	},
]
</script>


					<script lang="ts">
					import __hybridly_layout_0 from '~/resources/layouts/default.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
	<content-wrapper class="flex flex-col gap-8">
		<template v-for="section in roadmapSections" :key="section.name">
			<div>
				<h2 class="text-primary mb-4 rounded border-b py-2 text-2xl font-bold">
					{{ section.name }}
				</h2>

				<ul class="text-muted-foreground max-w-3xl list-inside list-disc">
					<li v-for="item in section.items" :key="item.content">
						{{ item.content }}
					</li>
				</ul>
			</div>
		</template>
	</content-wrapper>
</template>
